// extracted by mini-css-extract-plugin
module.exports = {"modalService":"ServiceModal_modalService__3l9nm","scrollViewComp":"ServiceModal_scrollViewComp__3UAJD","modalTitle":"ServiceModal_modalTitle__XpVGA"};